<template>
    <div>
        <section class="page-title" style="background-color:#c7eafb;">
            <div class="center">
                <v-layout row wrap>
                    <v-flex xs12 sm12 lg12 style="text-align: center;" v-if="this.$vuetify.breakpoint.lg">
                        <h1 class="the-title" style="font-size:50px;color:#00358d">FEDERAÇÃO DOS TRABALHADORES DE TRANSPORTE RODOVIÁRIO DE MINAS GERAIS</h1>
                    </v-flex>
                    <v-flex xs12 sm12 lg2 style="text-align: center;" v-else>
                        <h1 class="the-title" style="font-size:30px;color:#00358d">FEDERAÇÃO DOS TRABALHADORES DE TRANSPORTE RODOVIÁRIO DE MINAS GERAIS</h1>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center;" v-if="this.$vuetify.breakpoint.lg">
                        <br>
                        <img src="../Content/images/fettrominas.png" width="140" style="margin-right: 15px;">
                        <img src="../Content/images/fetcemg.png" width="140" style="margin-right: 15px;">
                        <img src="../Content/images/fetramovmg.png" width="140" style="margin-right: 15px;">
                    </v-flex>
                    <v-flex xs12 sm12 lg2 style="text-align: center;" v-else>
                        <img src="../Content/images/fettrominas.png" width="200" style="margin: 6px">
                        <img src="../Content/images/fetcemg.png" width="200" style="margin: 6px">
                        <img src="../Content/images/fetramovmg.png" width="200" style="margin: 6px">
                        <img src="../Content/images/setcom.jpg" width="200" style="margin: 6px">
                        <img src="../Content/images/sindinor.png" width="200" style="margin: 6px">
                        <img src="../Content/images/setcjf.png" width="200" style="margin: 6px">
                        <img src="../Content/images/setsul.jpg" width="200" style="margin: 6px">
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg10 style="text-align:center; margin-left:100px;" v-if="this.$vuetify.breakpoint.lg">
                        <br>
                        <v-btn class="custom-btn" href="/fettrominassetcemgmc" style="width:200px;margin:10px">
                            <img src="../Content/images/MONTES CLAROS - SETCEMG.png" style="width:250px;height:110px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominassetcemgd" style="width:200px;margin:10px">
                            <img src="../Content/images/DIVINOPOLIS - SETCEMG.png" style="width:250px;height:110px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominassetsul" style="width:200px;margin:10px">
                            <img src="../Content/images/POÇOS - PASSOS.png" style="width:250px;height:110px"/>
                        </v-btn>
                        <br>
                        <br>
                        <v-btn class="custom-btn" href="/fettrominassindinormc" style="width:200px;margin:10px">
                            <img src="../Content/images/MONTES CLAROS - SINDINOR.png" style="width:250px;height:110px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominassetcomd" style="width:200px;margin:10px">
                            <img src="../Content/images/DIVINOPOLIS - SETCOM.png" style="width:250px;height:110px"/>
                        </v-btn>                        
                        <v-btn class="custom-btn" href="/fettrominassetcjf" style="width:200px;margin:10px">
                            <img src="../Content/images/JUIZ DE FORA - SETCJF.png" style="width:250px;height:110px"/>
                        </v-btn>
                        <br>
                        <br>
                        <v-btn class="custom-btn" href="/fettrominasmuriae" style="width:200px;margin:10px">
                            <img src="../Content/images/muriae.png" style="width:250px;height:65px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominascontagem" style="width:200px;margin:10px">
                            <img src="../Content/images/contagem.png" style="width:250px;height:70px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasparademinas" style="width:200px;margin:10px">
                            <img src="../Content/images/para_de_minas.png" style="width:250px;height:95px"/>
                        </v-btn>
                        <br>
                        <br>
                        <v-btn class="custom-btn" href="/fettrominasparademinassetcemg" style="width:200px;margin:10px">
                            <img src="../Content/images/para_de_minas_setcemg.png" style="width:250px;height:95px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasparacatu" style="width:200px;margin:20px">
                          <img src="../Content/images/botao_paracatu.png" style="width:250px;height:115px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasbasemetropolitana" style="width:200px;margin:20px">
                          <img src="../Content/images/botao_base_metropolitana.png" style="width:250px;height:115px"/>
                        </v-btn>
                        <br>
                        <br>
                        <v-btn class="custom-btn" href="/fettrominasbarbacena" style="width:200px;margin:20px">
                          <img src="../Content/images/botao_barbacena.png" style="width:250px;height:115px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominassetelagoassetcemg" style="width:200px;margin:20px">
                          <img src="../Content/images/botaosetelagoassetcemg.png" style="width:250px;height:95px"/>
                        </v-btn>                    
                        <v-btn class="custom-btn" href="/fettrominaspatosminassetcemg" style="width:200px;margin:20px">
                          <img src="../Content/images/botaopatodeminassetcemg.png" style="width:250px;height:95px"/>
                        <br>
                        <br>
                        </v-btn>                    
                        <v-btn class="custom-btn" href="/fettrominasoteofilootonisetcemg" style="width:200px;margin:20px">
                          <img src="../Content/images/botaosttteofilootonisetsemg.png" style="width:250px;height:95px"/>
                        </v-btn>                    
                        <v-btn class="custom-btn" href="/fettrominasarcossetcemg" style="width:200px;margin:20px">
                          <img src="../Content/images/botaosttrarcossetcemg.png" style="width:250px;height:95px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasarcossetcom" style="width:200px;margin:20px">
                          <img src="../Content/images/botaosttrfetrominasarcossetcom.png" style="width:250px;height:95px"/>
                        </v-btn>
                        <br>
                        <br>
                         <!--  <v-btn class="custom-btn" href="/fettrominasitaunasetcom" style="width:200px;margin:20px">
                          <img src="../Content/images/botaosttritaunasetcom.png" style="width:250px;height:95px"/>
                        </v-btn>  -->
                        <v-btn class="custom-btn" href="/fettrominasvarginhasetcemg" style="width:200px;margin:20px">
                          <img src="../Content/images/botaovarginhasetcemg.png" style="width:250px;height:95px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasvarginhasetsul" style="width:200px;margin:20px">
                          <img src="../Content/images/botaovarginhasetsul.png" style="width:250px;height:95px"/>
                        </v-btn>                    
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg10 style="text-align:center;" v-else>
                        <br>
                        <v-btn class="custom-btn" href="/fettrominassetcemgmc" style="width:200px;margin:20px">
                            <img src="../Content/images/MONTES CLAROS - SETCEMG.png" style="width:250px;height:110px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominassetcemgd" style="width:200px;margin:20px">
                            <img src="../Content/images/DIVINOPOLIS - SETCEMG.png" style="width:250px;height:110px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominassetsul" style="width:200px;margin:20px">
                            <img src="../Content/images/POÇOS - PASSOS.png" style="width:250px;height:110px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominassindinormc" style="width:200px;margin:20px">
                            <img src="../Content/images/MONTES CLAROS - SINDINOR.png" style="width:250px;height:110px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominassetcomd" style="width:200px;margin:20px">
                            <img src="../Content/images/DIVINOPOLIS - SETCOM.png" style="width:250px;height:110px"/>
                        </v-btn>                        
                        <v-btn class="custom-btn" href="/fettrominassetcjf" style="width:200px;margin:20px">
                            <img src="../Content/images/JUIZ DE FORA - SETCJF.png" style="width:250px;height:110px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasmuriae" style="width:200px;margin:20px">
                            <img src="../Content/images/muriae.png" style="width:250px;height:65px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominascontagem" style="width:200px;margin:20px">
                            <img src="../Content/images/contagem.png" style="width:250px;height:70px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasparademinas" style="width:200px;margin:20px">
                            <img src="../Content/images/para_de_minas.png" style="width:250px;height:95px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasparademinassetcemg" style="width:200px;margin:20px">
                            <img src="../Content/images/para_de_minas_setcemg.png" style="width:250px;height:95px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasparacatu" style="width:200px;margin:20px">
                            <img src="../Content/images/botao_paracatu.png" style="width:250px;height:115px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasbasemetropolitana" style="width:200px;margin:20px">
                            <img src="../Content/images/botao_base_metropolitana.png" style="width:250px;height:115px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasbarbacena" style="width:200px;margin:20px">
                            <img src="../Content/images/botao_barbacena.png" style="width:250px;height:115px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominassetelagoassetcemg" style="width:200px;margin:20px">
                            <img src="../Content/images/botaosetelagoassetcemg.png" style="width:250px;height:95px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominaspatosminassetcemg" style="width:200px;margin:20px">
                            <img src="../Content/images/botaopatodeminassetcemg.png" style="width:250px;height:95px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasoteofilootonisetcemg" style="width:200px;margin:20px">
                            <img src="../Content/images/botaosttteofilootonisetsemg.png" style="width:250px;height:95px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasarcossetcemg" style="width:200px;margin:20px">
                            <img src="../Content/images/botaosttrarcossetcemg.png" style="width:250px;height:95px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasarcossetcom" style="width:200px;margin:20px">
                            <img src="../Content/images/botaosttrfetrominasarcossetcom.png" style="width:250px;height:95px"/>
                        </v-btn>
                      <!--   <v-btn class="custom-btn" href="/fettrominasitaunasetcom" style="width:200px;margin:20px">
                            <img src="../Content/images/botaosttritaunasetcom.png" style="width:250px;height:95px"/>
                        </v-btn>   -->
                        <v-btn class="custom-btn" href="/fettrominasvarginhasetcemg" style="width:200px;margin:20px">
                            <img src="../Content/images/botaovarginhasetcemg.png" style="width:250px;height:95px"/>
                        </v-btn>
                        <v-btn class="custom-btn" href="/fettrominasvarginhasetsul" style="width:200px;margin:20px">
                            <img src="../Content/images/botaovarginhasetsul.png" style="width:250px;height:95px"/>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </div>
        </section>

        <section class="page-content center">
            <v-layout row wrap>    
                <v-flex xs12 sm12 lg10>
                    <img v-if="this.$vuetify.breakpoint.lg" src="../Content/images/15e90.png" style="position: absolute;left: 90%;" width="150px">
                    <img v-else src="../Content/images/15e90.png" width="150px">
                    <p>A empresa deverá clicar no botão acima considerando sua área de atuação.</p>
                    <p>Informamos que encontra-se em vigor a CONVENÇÃO COLETIVA DE TRABALHO, registrada junto ao Ministério Público do Trabalho.</p>
                    <p>Serve este comunicado para que a empresa possa cumprir a Cláusula do Plano Odontológico para todos os seus trabalhadores, através da Operadora credenciada juntos ao Sindicato laboral.</p>

                    <p class="title-label"><strong>Sobre a PrimaVida Dental</strong></p>
                    <p>A PrimaVida Dental é uma operadora exclusivamente odontológica, atendendo há mais de 15 anos no segmento de saúde suplementar, com aproximadamente 260.000 beneficiários, mais de 8.000 prestadores em todo Brasil, e está devidamente registrada na Agência Nacional de Saúde Suplementar (ANS) sob o nº 416525.</p>
                    <p>Possui processo de gestão inovador, com tecnologia de ponta e modernidade, garante assim agilidade, segurança e a tranquilidade para seus associados.</p> 

                    <p class="title-label"><strong>Benefícios</strong></p>
                    <p>O Plano disponibilizado para a categoria possui cobertura para todo o Rol de Procedimentos da ANS – Agência Nacional de Saúde Suplementar, acrescido de 93 procedimentos extras, com utilização imediata dos serviços, por não possuir carência contratual. Além de ampla rede credenciada com inúmeras opções de atendimento e especialidades.</p>
                    <p>Com o mais alto nível de informatização, permite também por aplicativo “Smartphone ou Tablet” acesso à carteirinha virtual e rede credenciada, com a certeza de bom atendimento e qualidade, tudo com muita transparência e respeito.</p>
                    <p>Caso queiram, os empregados poderão incluir seus dependentes, ficando responsáveis pelo pagamento através do desconto em folha. Os mesmos deverão comunicar por escrito ao seu empregador.</p>

                    <ul class="title-label"><strong>Os Valores do plano contratado serão:</strong></ul>
                    <li style="font-weight: bold;">Funcionário: R$15,90 sendo 100% pago pela empresa.</li>
                    <li style="font-weight: bold;">Dependente: R$15,90 sendo 100% pago pelo titular (descontado em folha).</li>
                    <br>
                    <p style="font-weight: bold; font-size: 20px; color:#009b9b">Aproveite já a oportunidade e garanta o sorriso dos seus colaboradores com a PrimaVida Dental.</p>
                </v-flex>

                <v-flex xs12 sm12 lg12>
                    <img src="../Content/images/logo.png" width="200">
                </v-flex>

                <v-flex xs12 sm12 lg7>
                    <br>
                    <p class="title-label">Acesso à rede credenciada</p>
                    <p>Para acessar a rede credenciada, <a href="https://www.primavida.com.br/redecredenciada" target="_blank">clique aqui.</a></p>
                </v-flex>

                <v-flex xs12 sm12 lg6>
                    <p class="title-label">Quem pode aderir ao Plano?</p>
                    <li>Pai / Padrasto</li>
                    <li>Mãe / Madrasta</li>
                    <li>Filhos / Enteados</li>
                    <li>Cônjuge / Companheiro(a)</li>
                    <br>
                </v-flex>

                <v-flex xs12 sm12 lg6>
                    <p class="title-label">Principais Vantagens</p>
                    <li>Liberação on-line do seu plano de tratamento;</li>
                    <li>O Beneficiário pode incluir familiares e agregados;</li>
                    <li>Acesso a rede credenciada através do site www.primavida.com.br;</li>
                    <li>Desconto em medicamentos nas farmácias &nbsp;<img src="../Content/images/raia.jpg" width="60px"> &nbsp; <img src="../Content/images/drogasil.jpg" width="110px"></li>
                    <li>Central de Atendimento exclusiva por Whatsapp;</li>
                    <li>Aplicativo para Celular / Tablet com rede Credenciada;</li>
                    <li>Carteirinha Virtual;</li>
                    <li>Boleto Virtual;</li>
                    <br>
                </v-flex>
            
                <v-flex xs12 sm12 lg12>
                    <br>
                    <p class="title-label" style="color:#212121;">App PrimaVida Beneficiário</p>
                </v-flex>
                <v-flex xs5 sm5 lg2>
                    <img src="../Content/images/app_android.png" width="120px"><br>
                    <a href="https://play.google.com/store/apps/details?id=br.com.primavida.associado" target="_blank"><img src="../Content/images/android.png" width="120px"></a>&nbsp;
                </v-flex>
                <v-flex xs5 sm5 lg2>
                    <img src="../Content/images/app_apple.png" width="120px"><br>
                    <a href="https://apps.apple.com/br/app/primavida-dental-associado/id1464690839" target="_blank"><img src="../Content/images/apple_stote.png" width="120px" ></a>&nbsp;
                </v-flex>
                <v-flex xs5 sm5 lg2>
                    <img src="../Content/images/app_whats.png" width="120px"><br>
                    <a href="https://api.whatsapp.com/send?phone=5521971640379" target="_blank"><img src="../Content/images/whatsapp.png" width="120px" ></a>&nbsp;
                </v-flex>
                <v-flex xs5 sm5 lg3>
                    <img src="../Content/images/celular.png" width="130px"><br>
                </v-flex>

                <v-flex xs5 sm5 lg12>
                    <table cellpadding="0" cellspacing="0" border="1">
                        <tr >
                            <td style="color: #009b9b;">Plano: </td> 
                            <td>&nbsp; SMILE 2000 RJ </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Reg ANS nº: </td>
                            <td>&nbsp; 473.449/15-1 </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Tipo de Contratação: </td>
                            <td>&nbsp; COLETIVO EMPRESARIAL </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Formação de Preço: </td>
                            <td>&nbsp; PRÉ-ESTABELECIDO </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Área de Abrangênia/Atuação: </td>
                            <td>&nbsp; NACIONAL </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Segmetação Assistencial: </td>
                            <td>&nbsp; EXCLUSIVAMENTE ODONTOLÓGICA </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Carência: </td>
                            <td>&nbsp; SEM CARÊNCIA </td>
                        </tr>
                    </table>
                </v-flex>
            </v-layout>
            <br>
            <p class="title-label">Principais Coberturas (Rol da ANS +93 Procedimentos)</p>
            <div class="icone consultas">
                <span class="icon"></span>
                <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
            </div>
            <div class="icone urgencia">
                <span class="icon"></span>
                <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
            </div>
            <div class="icone cirurgia">
                <span class="icon"></span>
                <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
            </div>
            <div class="icone dentistica">
                <span class="icon"></span>
                <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
            </div>
            <div class="icone endodontia">
                <span class="icon"></span>
                <p><strong>Endodontia</strong> - Tratamento de canais;</p>
            </div>
            <div class="icone periodontia">
                <span class="icon"></span>
                <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
            </div>
            <div class="icone odontopediatria">
                <span class="icon"></span>
                <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
            </div>
            <div class="icone radiologia">
                <span class="icon"></span>
                <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico) e panorâmica;</p>
            </div>
            <div class="icone protese">
                <span class="icon"></span>
                <p><strong>Próteses</strong> - Coroa provisória, Restauração, Coroa, Núcleo e Bloco metálico para dentes permanentes posteriores, Coroa em Cerômero para dentes permanentes anteriores (Entende-se como dentes permanentes anteriores, os dentes definitivos da frente, que correspondem do canino a canino);</p>
            </div>
            <div class="icone profilaxia">
                <span class="icon"></span>
                <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
            </div>
            <div class="icone exodontia">
                <span class="icon"></span>
                <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
            </div>
            <div>
                <p>Para acessar a cobertura do Rol da ANS +93 procedimentos, favor <a href="https://www.primavida.com.br/emkt/rol_proced+93_extras.pdf" target="_blank">clique aqui.</a></p>
                <br>
            </div>
            <v-layout>
                <v-flex xs12 sm6 md6 lg12>
                    <v-btn style="border-radius: 6px; width: 200px" large dark href="https://ecommerce.primavida.com.br/contratos/FETTROMINAS/rol_ans_fettrominas.pdf" target="_blank" color="#00358d">Ficha de Adesão</v-btn>
                    <br>
                    <v-btn style="border-radius: 6px; width: 200px" large dark href="https://wa.me/552132994501?text=Olá,%20pode%20me%20ajudar?" target="_blank" color="#00358d">Fale Conosco</v-btn>
                    <br>
                    <v-btn style="border-radius: 6px; width: 200px" large dark href="https://www.primavida.com.br/emkt/planilha_carga.xlsx" target="_blank" color="#00358d">Planilha de Carga</v-btn>
                    <br v-if="!this.$vuetify.breakpoint.lg">
                    <br v-if="!this.$vuetify.breakpoint.lg">
                    <img v-if="this.$vuetify.breakpoint.lg" src="../Content/images/logo-ans.png" width="200" style="float:right;">
                    <img v-if="!this.$vuetify.breakpoint.lg" src="../Content/images/logo-ans.png" width="200">
                </v-flex>
            </v-layout>
        </section>
        <Snackbar ref=chamaSnackbar />
    </div>
</template>

<script>
    import Snackbar from '../components/snackbar.vue'
    export default {
        components: {Snackbar},
        data() {
            return {
                contrataccept: false,
                dialog: false,
                matricula: '',
                dictionary: {
                    custom: {
                        carteirinha: {
                            required: () => 'Informe o número da carteirinha'
                        }
                    }
                }
            }
        },

        mounted : function() {
            this.$store.dispatch('EscondeToolbar')
            this.$store.dispatch('EscondeFooter')
            this.$validator.localize('pt', this.dictionary)
            localStorage.clear()
            sessionStorage.clear()
        },

        watch: {
            dialog(val) {
                val || this.close()
            }
        },

        methods: {
            openDialog() {
                this.dialog = true
            },
        }
    }
</script>

<style>
    .link {
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }

    .titulo {
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }

    .tabela {
        border-collapse: separate;
        border-spacing: 2;
    }
</style>